var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5991 13.6546L10.5964 6.19803L17.801 9.94033L10.5991 13.6546ZM26.4149 4.90616C26.4149 4.90616 26.1536 3.077 25.3536 2.27175C24.3404 1.21452 23.2032 1.20918 22.6819 1.14919C18.9516 0.879882 13.3561 0.879883 13.3561 0.879883H13.3455C13.3455 0.879883 7.74603 0.879882 4.01573 1.14919C3.49578 1.20918 2.35989 1.21585 1.34399 2.27175C0.545404 3.077 0.28543 4.90616 0.28543 4.90616C0.28543 4.90616 0.0174561 7.05261 0.0174561 9.20173V11.2149C0.0174561 13.3627 0.284096 15.5104 0.284096 15.5104C0.284096 15.5104 0.545404 17.3396 1.34399 18.1449C2.35989 19.2021 3.6931 19.1674 4.28504 19.2781C6.41816 19.4821 13.3495 19.5447 13.3495 19.5447C13.3495 19.5447 18.9516 19.5354 22.6832 19.2674C23.2045 19.2074 24.3417 19.2008 25.355 18.1449C26.1549 17.3396 26.4162 15.5104 26.4162 15.5104C26.4162 15.5104 26.6815 13.364 26.6815 11.2149V9.20173C26.6815 7.05394 26.4162 4.90616 26.4162 4.90616H26.4149Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b63045243e42f46c2c1e91da3ff661dd.svg";
export { ForwardRef as ReactComponent };